import { render, staticRenderFns } from "./ACTdetail.vue?vue&type=template&id=0851260f&scoped=true"
import script from "./ACTdetail.vue?vue&type=script&lang=js"
export * from "./ACTdetail.vue?vue&type=script&lang=js"
import style0 from "./ACTdetail.vue?vue&type=style&index=0&id=0851260f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0851260f",
  null
  
)

export default component.exports